import React from "react";
async function validate_plateform(props) {
  const plateform = props.match.params.plateform;
  localStorage.setItem("plateform", plateform);
  window.location.href = "/login";
  return <> </>;
}

export default validate_plateform;
